import { DashboardWidgetType } from 'features/dashboard/types'
import { InsightData } from 'schemas/action/InsightDataSchema'
import generateStaticStrategy from './staticStrategy'
import { WidgetSettingComposingStrategy } from './widgetSettingComposingStrategy'
import { pivotTagDecorator } from './decorator'

const generatePivotTagStrategy = (applicationSettings: any): WidgetSettingComposingStrategy => {
  const staticStrategy = generateStaticStrategy()
  const decoratedStrategy = pivotTagDecorator(applicationSettings, staticStrategy)

  return {
    ...decoratedStrategy,
    composeDrillDownWidgetSetting: (widgetSetting: DashboardWidgetType, insights: InsightData[]) =>
      decoratedStrategy.composeDrillDownWidgetSetting(widgetSetting, [], insights)
  }
}

export default generatePivotTagStrategy
